







































































































































































































































































































import { types } from '../../store/types/types.js';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import { moduleWidgetPlacements } from '../../../shared/enums/moduleWidgetPlacements';
import { permissionEnum } from '../../../shared/enums/permissionEnum.ts';
import { institutionRole } from '../../../shared/enums/institutionRole';
import NewPost from './NewPost.vue';
import Birthdays from '../shared/Birthdays.vue';
import moment from 'moment-timezone';
import Alerts from '../../../shared/components/Alerts.vue';
import MultiButtonMobile from '../shared/MultiButtonMobile.vue';
import { portalRoles } from '../../../shared/enums/portalRoles';
import { parentTypes } from '../../../shared/enums/parentTypes.ts';
import { moduleTypes } from '../../../shared/enums/moduleTypes';
import { displayMode } from '../../../shared/enums/displayMode';
import { Cookie } from '../../../shared/assets/plugins/cookie.js';
import { filterGroupMembershipInstitutions } from '../../../shared/utils/institutionUtil.js';
import toUpper from 'lodash/toUpper';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import ImportantDateOverview from '../shared/ImportantDateOverview.vue';
import DailyOverview from '../shared/DailyOverview.vue';
import WidgetPlaceholder from '../widgets/WidgetPlaceholder.vue';
import { institutionTypes } from '../../../shared/enums/institutionTypes';
import { providerKeyTypes } from '../../../shared/enums/providerKeyTypes.js';
import { notificationAreas } from '../../../shared/enums/notificationAreas';
import AulaNavigationToolbar from '../../../shared/components/navigation/AulaNavigationToolbar.vue';
import AulaButton from '../../../shared/components/AulaButton.vue';
import AulaButtons from '../../../shared/components/AulaButtons.vue';
import ObservingContainer from '../../../shared/libs/intersection-observer/components/Container.vue';
import ObservedTarget from '../../../shared/libs/intersection-observer/components/Target.vue';
import { isEarlyStudent } from '../../../shared/functions/is-early-student.js';
import { postFilterTypes } from '../../../shared/enums/postFilterTypes';
import PostList from './PostList.vue';
import { useUserProfileStore } from '../../../shared/stores';
import { useNotificationStore } from '../../../shared/stores/notification';

export default {
  components: {
    PostList,
    ObservedTarget,
    ObservingContainer,
    AulaButtons,
    AulaButton,
    AulaNavigationToolbar,
    DailyOverview,
    ImportantDateOverview,
    alerts: Alerts,
    NewPost,
    Birthdays,
    MultiButtonMobile,
    WidgetPlaceholder,
  },
  provide() {
    return {
      [providerKeyTypes.onRemoveMediaFromAlbum]: attachment => {
        const post = this.posts[this.parent].find(post => post.id == this.$route.params.postId);
        this.removeAttachmentFromPost({ parent: this.parent, post, attachment });
      },
    };
  },
  beforeRouteLeave(to, from, next) {
    if (this.writingComment) {
      this.nextRoute = next;
      this.$refs.cancelCommentModal.show();
    } else {
      next();
    }
  },
  props: {
    parent: { type: String, default: parentTypes.PROFILE },
  },
  data: function () {
    return {
      loading: false,
      editPostId: undefined,
      loadingMore: false,
      moment: moment,
      permissionEnum: permissionEnum,
      institutionRole: institutionRole,
      portalRoles: portalRoles,
      parentTypes: parentTypes,
      moduleTypes: moduleTypes,
      drawerShow: false,
      title: 'Seneste',
      newPostTitle: '',
      newPostText: '',
      newPostSharedWith: '',
      showUsersToShareWith: false,
      chosenFilter: postFilterTypes.ALL,
      reportedContentReason: '',
      nextRoute: '',
      showWarningReasonLength: false,
      warningReasonLength: null,
      postIdToDelete: '',
      postIndex: 0,
      postPageComponent: 'overview',
      cachedUnreadPosts: [],
      cachedNotifications: [],
    };
  },
  computed: {
    ...mapGetters({
      date: types.GET_DATE,
      time: types.GET_TIME,
      posts: types.GET_POSTS,
      morePostsExist: types.GET_MORE_POSTS_EXIST,
      children: types.GET_CHILDREN,
      activeChildren: types.GET_ACTIVE_CHILDREN,
      activeInstitutions: types.GET_ACTIVE_INSTITUTIONS,
      institutions: types.GET_INSTITUTIONS,
      userGroups: types.GET_USER_GROUPS,
      hasPermission: types.HAS_PERMISSION,
      group: types.GET_ACTIVE_GROUP,
      hasPermissionGroup: types.HAS_PERMISSION_ON_GROUP,
      hasPermissionOnInstitution: types.HAS_PERMISSION_ON_INSTITUTION,
      isSteppedUp: types.GET_GLOBAL_STEPPED_UP,
      isPreviewMode: types.GET_IS_PREVIEW_MODE,
      moduleWidgetConfig: types.GET_PAGE_CONFIGURATION,
      menuItems: types.GET_MENU_ITEMS,
      isMobile: types.GET_IS_MOBILE,
      writingComment: types.GET_WRITING_COMMENT,
      notifications: types.GET_NOTIFICATIONS,
      hasNonBlockingProfiles: types.GET_HAS_NON_BLOCKING_PROFILES,
    }),
    notificationStore() {
      return useNotificationStore();
    },
    userProfileStore() {
      return useUserProfileStore();
    },
    profile() {
      return this.userProfileStore.institutionProfile;
    },
    isVisibleBookmarkInfo() {
      return this.chosenFilter === postFilterTypes.BOOKMARKED && this.currentPosts.length > 0;
    },
    isProfileLoaded() {
      return this.userProfileStore.isLoading === false;
    },
    isLoadingNotifications() {
      return this.notificationStore.isLoading;
    },
    showCreateButton() {
      if (this.parent === parentTypes.PROFILE) {
        const isBlockCommunication = this.profile.communicationBlock && !this.hasNonBlockingProfiles;
        return !isBlockCommunication && !this.isPreviewMode && this.hasCreateOptions;
      }
      if (this.parent === parentTypes.GROUP) {
        const memberInstitutions = filterGroupMembershipInstitutions(this.institutions, this.group);
        const isBlockCommunication = memberInstitutions.every(inst => inst.communicationBlock);
        return (
          !isBlockCommunication &&
          this.group != null &&
          (this.hasPermissionGroup(permissionEnum.WRITE_POST, this.group.id) ||
            this.hasPermissionOnInstitution(
              permissionEnum.USE_GROUPS_AS_DISTRIBUTION_LISTS,
              this.group.institutionCode
            ))
        );
      }
      return false;
    },
    hasCreateOptions() {
      return this.multiButtonItems.some(
        item => this.hasOneOfTheFollowingPermissions(item.permissions) && this.hasModule(item.module)
      );
    },
    notificationAreas() {
      return [
        notificationAreas.POSTS,
        notificationAreas.CALENDAR,
        notificationAreas.PRESENCE,
        notificationAreas.MESSAGES,
        notificationAreas.FILE_SCANNING,
      ];
    },
    observerOptions() {
      return { rootMargin: '50%' };
    },
    currentPosts() {
      const basePosts = this.posts[this.parent] || [];

      if (this.chosenFilter === postFilterTypes.UNREAD) {
        const basePostIds = new Set(basePosts.map(post => post.id));
        const cachedPosts = this.cachedUnreadPosts.filter(post => !basePostIds.has(post.id));
        return [...basePosts, ...cachedPosts];
      }
      if (this.chosenFilter === postFilterTypes.BOOKMARKED) {
        return basePosts.filter(post => post.isBookmarked === true);
      }

      return basePosts;
    },
    isOnNoticeBoard() {
      return this.$route.name === 'notice-board';
    },
    postPageLayout() {
      if (this.parent === parentTypes.GROUP) {
        return '';
      }
      return 'posts';
    },
    configSections() {
      const defaultSections = [
        {
          name: 'POSTS_FILTER_ALL',
          filter: postFilterTypes.ALL,
          portalRoles: [portalRoles.EMPLOYEE, portalRoles.CHILD, portalRoles.GUARDIAN, portalRoles.OTP],
        },
        {
          name: 'POSTS_FILTER_UNREAD',
          filter: postFilterTypes.UNREAD,
          portalRoles: [portalRoles.EMPLOYEE, portalRoles.CHILD, portalRoles.GUARDIAN, portalRoles.OTP],
        },
        {
          name: 'POSTS_FILTER_MARKED',
          filter: postFilterTypes.MARKED,
          portalRoles: [portalRoles.EMPLOYEE, portalRoles.CHILD, portalRoles.GUARDIAN, portalRoles.OTP],
        },
        {
          name: 'POSTS_FILTER_EMPLOYEES',
          filter: postFilterTypes.EMPLOYEES,
          portalRoles: [portalRoles.EMPLOYEE],
        },
        {
          name: 'POSTS_FILTER_STAFFS',
          filter: postFilterTypes.STAFFS,
          portalRoles: [portalRoles.CHILD, portalRoles.GUARDIAN, portalRoles.OTP],
        },
        {
          name: 'POSTS_FILTER_PARENTS',
          filter: postFilterTypes.PARENTS,
          portalRoles: [portalRoles.GUARDIAN, portalRoles.OTP],
        },
        {
          name: 'POSTS_FILTER_STUDENTS',
          filter: postFilterTypes.STUDENTS,
          portalRoles: [portalRoles.CHILD],
        },
        {
          name: 'POSTS_FILTER_OWN',
          filter: postFilterTypes.OWN_POST,
          portalRoles: [portalRoles.EMPLOYEE, portalRoles.CHILD, portalRoles.GUARDIAN],
        },
        {
          name: 'POSTS_FILTER_BOOKMARK',
          filter: postFilterTypes.BOOKMARKED,
          portalRoles: [portalRoles.EMPLOYEE, portalRoles.CHILD, portalRoles.GUARDIAN, portalRoles.OTP],
        },
      ];
      return defaultSections.filter(section => section.portalRoles.includes(this.profile.role));
    },
    noPosts() {
      const suffix = this.chosenFilter === 'all' ? '' : '_' + toUpper(this.chosenFilter);
      return this.$getText('NO_POSTS' + suffix);
    },
    multiButtonItems() {
      const multiButtonItems = [
        {
          icon: 'icon-Aula_home',
          text: 'POSTS_MENU_LABEL_HOME',
          label: 'POSTS_MENU_LABEL_CREATE_POST',
          action: 'newPost',
          permissions: [permissionEnum.WRITE_POST, permissionEnum.USE_GROUPS_AS_DISTRIBUTION_LISTS],
          module: moduleTypes.OVERVIEW,
        },
        {
          icon: 'icon-Aula_calendar',
          text: 'POSTS_MENU_LABEL_CALENDARPOST',
          label: 'POSTS_MENU_LABEL_CREATE_CALENDARPOST',
          action: 'newEvent',
          permissions: [permissionEnum.HANDLE_EVENTS],
          module: moduleTypes.CALENDAR,
        },
        {
          icon: 'icon-Aula_calendar',
          text: 'POSTS_CREATE_LABEL_MEETING',
          label: 'POSTS_MENU_LABEL_CREATE_PARENT_MEETING_POST',
          action: 'newMeetingEvent',
          permissions: [
            permissionEnum.HANDLE_PARENTAL_MEETING_SCHOOL,
            permissionEnum.HANDLE_PARENTAL_MEETING_DAYCARE,
            permissionEnum.HANDLE_PERFORMANCE_MEETING,
          ],
          module: moduleTypes.CALENDAR,
        },
        {
          icon: isEarlyStudent(this.profile) ? 'icon-Aula_write' : 'icon-Aula_conversation',
          text: 'POSTS_MENU_LABEL_NEW_MESSAGE',
          label: 'POSTS_MENU_LABEL_CREATE_MESSAGE',
          action: 'newMessage',
          permissions: [permissionEnum.WRITE_MESSAGE],
          module: moduleTypes.MESSAGES,
        },
        {
          icon: 'icon-Aula_picture',
          text: 'POSTS_MENU_LABEL_ALBUM',
          label: 'POSTS_MENU_LABEL_CREATE_ALBUM',
          action: 'newAlbum',
          permissions: [permissionEnum.HANDLE_MEDIA],
          module: moduleTypes.GALLERY,
        },
        {
          icon: 'icon-Aula_paper',
          text: 'POSTS_MENU_LABEL_SECURE_FILE_SHARING',
          label: 'POSTS_MENU_LABEL_SECURE_FILE_SHARING',
          action: 'checkStepUp',
          permissions: [permissionEnum.HANDLE_SECURE_FILES],
          module: moduleTypes.DOCUMENTS,
        },
        {
          icon: 'icon-Aula_paper',
          text: 'POSTS_MENU_LABEL_SECURE_FILE_NOTE',
          label: 'POSTS_MENU_LABEL_SECURE_FILE_NOTE',
          action: 'checkStepUpForNote',
          permissions: [permissionEnum.HANDLE_SECURE_FILES],
          module: moduleTypes.DOCUMENTS,
        },
      ];

      return multiButtonItems;
    },
    multiButtonGroupItems() {
      const multiButtonItems = [
        {
          icon: 'icon-Aula_home',
          text: 'POSTS_MENU_LABEL_HOME',
          label: 'POSTS_MENU_LABEL_CREATE_POST',
          action: 'newPost',
        },
      ];
      return multiButtonItems;
    },
    getListWidgets() {
      return this.menuItems != undefined ? this.menuItems[moduleWidgetPlacements.RIGHT_OF_OVERVIEW] : [];
    },
  },
  watch: {
    activeChildren() {
      if (this.profile.role === portalRoles.GUARDIAN || this.profile.role === portalRoles.OTP) {
        this.reload();
      }
    },
    activeInstitutions() {
      if (
        this.institutions.length > 1 &&
        this.activeInstitutions.length > 0 &&
        this.profile.role === portalRoles.EMPLOYEE
      ) {
        this.reload();
      }
    },
    profile(to, from) {
      if (!isEqual(to, from) && !this.loading && this.isProfileLoaded) {
        this.reload();
      }
    },
    userGroups(to) {
      if (to.length && !this.loading && this.isProfileLoaded) {
        this.reload();
      }
    },
    group(to) {
      isEmpty(to) && this.reload();
    },
    isLoadingNotifications: {
      immediate: true,
      handler(value) {
        if (value === false) {
          this.cachedNotifications = [...this.notifications];
        }
      },
    },
  },
  mounted() {
    if (this.parent !== parentTypes.PROFILE && this.$router.currentRoute.query.filter) {
      this.chosenFilter = this.$router.currentRoute.query.filter;
    }
    if (!this.loading) {
      this.getPosts();
    }
    if (!this.isMobile && this.parent == parentTypes.PROFILE) {
      setTimeout(() => {
        const postTitle = this.$el.querySelector('.post-header-container .posts-title');
        if (postTitle) {
          postTitle.focus();
        }
      }, 500);
    }
  },
  destroyed() {
    this.resetPosts();
  },
  methods: {
    isEarlyStudent,
    onBottomReached() {
      if (this.loading || !this.morePostsExist) {
        return;
      }
      this.getPosts();
    },
    onTabItemClicked(section) {
      this.chosenFilter = section.filter;
      this.reload();
    },
    hasOneOfTheFollowingPermissions(permissions) {
      if (!permissions) {
        return true;
      }
      for (const permission of permissions) {
        if (this.hasPermission(permission)) {
          return true;
        }
      }
      return false;
    },
    hasModule(moduleType) {
      if (!moduleType) {
        return true;
      }
      if (this.moduleWidgetConfig.moduleConfigurations != null) {
        for (const item of this.moduleWidgetConfig.moduleConfigurations) {
          if (item.module.type == moduleType && item.aggregatedDisplayMode == displayMode.SHOWN) {
            return true;
          }
        }
      }
      return false;
    },
    executeMethodDynamically(action) {
      this[action]();
    },
    getFilterAriaLabel(name) {
      return this.$getText('ARIA_LABEL_SHOW_POSTS_FROM') + this.$getText(name);
    },
    checkStepUp() {
      if (this.isSteppedUp) {
        this.$router.push({
          name: 'documentsSecureNew',
          params: { institutionCode: this.profile.institutionCode },
        });
      } else {
        this.setStepUpNotification({
          showStepUpNotification: true,
          redirectedUrl: window.location.href,
        });
      }
    },
    checkStepUpForNote() {
      if (this.isSteppedUp) {
        this.$router.push({
          name: 'createDocumentNote',
          params: { institutionCode: this.profile.institutionCode },
        });
      } else {
        this.setStepUpNotification({
          showStepUpNotification: true,
          redirectedUrl: window.location.href,
        });
      }
    },
    newAlbum() {
      this.$router.push({ name: 'createAlbum' });
    },
    newEvent() {
      this.$router.push('/kalender/opretbegivenhed');
    },
    newPost() {
      this.editPostId = undefined;
      if (!this.isPreviewMode) {
        if (
          !(
            this.hasPermission(permissionEnum.WRITE_POST) ||
            this.hasPermission(permissionEnum.USE_GROUPS_AS_DISTRIBUTION_LISTS)
          )
        ) {
          this.$refs.warningPreventModal.show();
        } else {
          this.drawerShow = true;
        }
      }
    },
    newMessage() {
      this.$router.push({ name: 'newMessage' });
    },
    newMeetingEvent() {
      this.$router.push({ name: 'createMeetingEvent' });
    },
    editPost(postId) {
      if (this.parent === parentTypes.PROFILE) {
        if (!this.isPreviewMode) {
          if (
            !(
              this.hasPermission(permissionEnum.WRITE_POST) ||
              this.hasPermission(permissionEnum.USE_GROUPS_AS_DISTRIBUTION_LISTS)
            )
          ) {
            this.$refs.warningPreventModal.show();
          } else {
            this.editPostId = postId;
            this.drawerShow = true;
          }
        }
      } else {
        this.$router.push({ name: 'group-edit-post', params: { id: postId }, query: { filter: this.chosenFilter } });
      }
    },
    reportPostClicked(postId) {
      const isBlockCommunication = this.profile.communicationBlock && !this.hasNonBlockingProfiles;
      if (isBlockCommunication) {
        this.$refs.blockedCommunicationModal.show();
      } else {
        this.postIdToDelete = postId;
        this.reportedContentReason = '';
        this.resetCommentForm();
        this.$refs.reportContentModal.show();
      }
    },
    resetCommentForm() {
      this.showWarningReasonLength = false;
      this.warningReasonLength = null;
    },
    saveReportPost() {
      if (this.reportedContentReason.length < 10 || this.reportedContentReason.length > 255) {
        this.showWarningReasonLength = true;
        this.warningReasonLength =
          this.reportedContentReason.length < 10
            ? 'REPORTED_CONTENT_REASON_LENGTH_WARNING_TOO_SHORT'
            : 'REPORTED_CONTENT_REASON_LENGTH_WARNING_TOO_LONG';
      } else {
        this.resetCommentForm();

        this.reportPost({
          id: this.postIdToDelete,
          reportReason: this.reportedContentReason,
        }).then(() => {
          this.$refs.reportContentModal.hide();
          this.reportedContentReason = '';
          this.mutateRemovePostById({ id: this.postIdToDelete, parent: this.parent });
        });
      }
    },
    changeDrawerShow() {
      this.drawerShow = !this.drawerShow;
    },
    closeDrawer() {
      this.drawerShow = false;
      this.editPostId = undefined;
    },
    postSubmitted() {
      this.closeDrawer();
      this.reload();
      this.scrollTop();
    },
    scrollTop() {
      window.scrollTo(0, 0);
    },
    newInlinePost() {
      if (!this.isPreviewMode) {
        if (
          !(
            this.hasPermission(permissionEnum.WRITE_POST) ||
            this.hasPermission(permissionEnum.USE_GROUPS_AS_DISTRIBUTION_LISTS)
          )
        ) {
          this.$refs.warningDialogVisible.show();
        } else {
          this.$router.push({ name: 'group-create-post', query: { filter: this.chosenFilter } });
        }
      }
    },
    async getPosts() {
      const parent = this.parent;
      let institutionProfileIds = [];
      let groupId = null;
      let isImportant = null;
      let ownPost = null;
      let isBookmarked = null;
      let isUnread = null;
      let creatorPortalRole = null;
      const limit = 10;

      if (this.profile?.role == portalRoles.EMPLOYEE) {
        institutionProfileIds = this.institutions
          .filter(inst => this.activeInstitutions.includes(inst.institutionCode))
          .map(inst => inst.institutionProfileId);
      } else if (this.profile?.role == portalRoles.GUARDIAN) {
        institutionProfileIds = this.institutions.map(inst => inst.institutionProfileId);
        institutionProfileIds = institutionProfileIds.concat(
          this.children.filter(child => this.activeChildren.includes(child.id)).map(child => child.id)
        );
      } else if (this.profile?.role == portalRoles.CHILD) {
        institutionProfileIds = this.institutions.map(inst => inst.institutionProfileId);
      } else if (this.profile?.role == portalRoles.OTP) {
        institutionProfileIds = this.activeChildren;
        institutionProfileIds = institutionProfileIds.concat(
          this.institutions
            .filter(inst => inst.children.filter(child => this.activeChildren.includes(child.id)).length > 0)
            .map(inst => inst.institutionProfileId)
        );
      }

      if (this.parent === parentTypes.GROUP) {
        groupId = this.$route.params.groupId;
      }

      this.loading = true;

      switch (this.chosenFilter) {
        case postFilterTypes.MARKED:
          isImportant = true;
          break;
        case postFilterTypes.UNREAD:
          isUnread = true;
          break;
        case postFilterTypes.STAFFS:
        case postFilterTypes.EMPLOYEES:
          creatorPortalRole = portalRoles.EMPLOYEE;
          break;
        case postFilterTypes.STUDENTS:
          creatorPortalRole = portalRoles.CHILD;
          break;
        case postFilterTypes.PARENTS:
          creatorPortalRole = portalRoles.GUARDIAN;
          break;
        case postFilterTypes.OWN_POST:
          ownPost = true;
          break;
        case postFilterTypes.BOOKMARKED:
          isBookmarked = true;
          break;
      }

      const payload = {
        groupId,
        parent,
        index: this.postIndex,
        isImportant,
        isUnread,
        ownPost,
        isBookmarked,
        creatorPortalRole,
        institutionProfileIds,
        limit,
      };
      if (Cookie.Read('fromAdminGroup') && this.parent == parentTypes.GROUP && groupId != null) {
        if (
          this.hasPermissionOnInstitution(this.permissionEnum.SEARCH_ACCESS_GROUPS, this.group.institutionCode) ||
          (this.hasPermission(this.permissionEnum.SEARCH_ACCESS_GROUPS) &&
            this.institutions.find(institution => institution.institutionType == institutionTypes.MUNICIPALITY))
        ) {
          await this.loadAdminPosts(payload);
        }
      } else if (this.parent === parentTypes.NOTICE_BOARDS) {
        await this.loadNoticeBoardPosts(payload);
      } else {
        await this.loadPosts(payload);
      }
      this.loading = false;
      this.postIndex += limit;
    },
    deleteThisPost() {
      this.deletePost({ id: this.postIdToDelete }).then(() => {
        this.$refs.deleteModal.hide();
        this.mutateRemovePostById({ id: this.postIdToDelete, parent: this.parent });
      });
    },
    showDeleteModal(id) {
      this.postIdToDelete = id;
      this.$refs.deleteModal.show();
    },
    reload() {
      this.postIndex = 0;
      this.resetPosts();
      this.getPosts();
    },
    addPostToUnreadCache(postId) {
      if (!this.cachedUnreadPosts.some(post => post.id === postId)) {
        const post = this.currentPosts.find(p => p.id === postId);
        if (post) {
          this.cachedUnreadPosts.push(post);
        }
      }
    },
    ...mapActions({
      toggleEventForm: types.TOGGLE_EVENT_FORM,
      loadPosts: types.ACTION_GET_POSTS,
      loadAdminPosts: types.ACTION_GET_POSTS_ADMIN,
      loadNoticeBoardPosts: types.LOAD_NOTICE_BOARD_POSTS,
      deletePost: types.ACTIONS_DELETE_POST,
      reportPost: types.REPORT_POST,
      removeAttachmentFromPost: types.SLICE_ATTACHMENT_FROM_POST,
      loadNotifications: types.LOAD_NOTIFICATIONS,
    }),
    ...mapMutations({
      setStepUpNotification: types.MUTATE_SET_NOTIFICATION_STEP_UP,
      updateWritingComment: types.MUTATE_WRITING_COMMENT,
      mutateRemovePostById: types.MUTATE_REMOVE_POST_BY_ID,
      resetPosts: types.MUTATE_EMPTY_POSTS,
    }),
  },
};
